var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMenuAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Grid_Line",
    "data-name": "icons/Grid/Line",
    transform: "translate(1.906 1.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.642,1.619a11.524,11.524,0,0,0-1.421.124.553.553,0,0,0-.478.478,11.524,11.524,0,0,0-.124,1.421,11.524,11.524,0,0,0,.124,1.421.553.553,0,0,0,.478.478,11.524,11.524,0,0,0,1.421.124,11.524,11.524,0,0,0,1.421-.124.553.553,0,0,0,.478-.478,11.524,11.524,0,0,0,.124-1.421,11.524,11.524,0,0,0-.124-1.421.553.553,0,0,0-.478-.478A11.524,11.524,0,0,0,3.642,1.619ZM2,.139A2.172,2.172,0,0,0,.139,2,13.019,13.019,0,0,0,0,3.642,13.019,13.019,0,0,0,.139,5.283,2.172,2.172,0,0,0,2,7.145a13.02,13.02,0,0,0,1.641.139,13.02,13.02,0,0,0,1.641-.139A2.172,2.172,0,0,0,7.145,5.283a13.02,13.02,0,0,0,.139-1.641A13.02,13.02,0,0,0,7.145,2,2.172,2.172,0,0,0,5.283.139,13.019,13.019,0,0,0,3.642,0,13.019,13.019,0,0,0,2,.139Z",
    transform: "translate(10.903 10.903)",
    fill: "#353945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.642,1.619a11.524,11.524,0,0,0-1.421.124.553.553,0,0,0-.478.478,11.524,11.524,0,0,0-.124,1.421,11.524,11.524,0,0,0,.124,1.421.553.553,0,0,0,.478.478,11.524,11.524,0,0,0,1.421.124,11.524,11.524,0,0,0,1.421-.124.553.553,0,0,0,.478-.478,11.524,11.524,0,0,0,.124-1.421,11.524,11.524,0,0,0-.124-1.421.553.553,0,0,0-.478-.478A11.524,11.524,0,0,0,3.642,1.619ZM2,.139A2.172,2.172,0,0,0,.139,2,13.019,13.019,0,0,0,0,3.642,13.019,13.019,0,0,0,.139,5.283,2.172,2.172,0,0,0,2,7.145a13.02,13.02,0,0,0,1.641.139,13.02,13.02,0,0,0,1.641-.139A2.172,2.172,0,0,0,7.145,5.283a13.02,13.02,0,0,0,.139-1.641A13.02,13.02,0,0,0,7.145,2,2.172,2.172,0,0,0,5.283.139,13.019,13.019,0,0,0,3.642,0,13.019,13.019,0,0,0,2,.139Z",
    transform: "translate(2 10.903)",
    fill: "#353945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M3.642,1.619a11.524,11.524,0,0,0-1.421.124.553.553,0,0,0-.478.478,11.524,11.524,0,0,0-.124,1.421,11.524,11.524,0,0,0,.124,1.421.553.553,0,0,0,.478.478,11.524,11.524,0,0,0,1.421.124,11.524,11.524,0,0,0,1.421-.124.553.553,0,0,0,.478-.478,11.524,11.524,0,0,0,.124-1.421,11.524,11.524,0,0,0-.124-1.421.553.553,0,0,0-.478-.478A11.524,11.524,0,0,0,3.642,1.619ZM2,.139A2.172,2.172,0,0,0,.139,2,13.019,13.019,0,0,0,0,3.642,13.019,13.019,0,0,0,.139,5.283,2.172,2.172,0,0,0,2,7.145a13.02,13.02,0,0,0,1.641.139,13.02,13.02,0,0,0,1.641-.139A2.172,2.172,0,0,0,7.145,5.283a13.02,13.02,0,0,0,.139-1.641A13.02,13.02,0,0,0,7.145,2,2.172,2.172,0,0,0,5.283.139,13.019,13.019,0,0,0,3.642,0,13.019,13.019,0,0,0,2,.139Z",
    transform: "translate(10.903 2)",
    fill: "#353945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M3.642,1.619a11.524,11.524,0,0,0-1.421.124.553.553,0,0,0-.478.478,11.524,11.524,0,0,0-.124,1.421,11.524,11.524,0,0,0,.124,1.421.553.553,0,0,0,.478.478,11.524,11.524,0,0,0,1.421.124,11.524,11.524,0,0,0,1.421-.124.553.553,0,0,0,.478-.478,11.524,11.524,0,0,0,.124-1.421,11.524,11.524,0,0,0-.124-1.421.553.553,0,0,0-.478-.478A11.524,11.524,0,0,0,3.642,1.619ZM2,.139A2.172,2.172,0,0,0,.139,2,13.019,13.019,0,0,0,0,3.642,13.019,13.019,0,0,0,.139,5.283,2.172,2.172,0,0,0,2,7.145a13.02,13.02,0,0,0,1.641.139,13.02,13.02,0,0,0,1.641-.139A2.172,2.172,0,0,0,7.145,5.283a13.02,13.02,0,0,0,.139-1.641A13.02,13.02,0,0,0,7.145,2,2.172,2.172,0,0,0,5.283.139,13.019,13.019,0,0,0,3.642,0,13.019,13.019,0,0,0,2,.139Z",
    transform: "translate(2 2)",
    fill: "#353945",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuAccount);
export default __webpack_public_path__ + "static/media/accountMenuAccount.67825bd769469886c217dce5ad838d78.svg";
export { ForwardRef as ReactComponent };